// Thermal Conductivity units with conversion factors to watt per meter kelvin (W/(m·K))
export const thermalConductivityUnits = [
  { id: 'watt-per-meter-kelvin', name: 'Watt/Meter·K', symbol: 'W/(m·K)', plural: 'Watts/Meter·K', factor: 1 },
  { id: 'watt-per-centimeter-celsius', name: 'Watt/Centimeter·°C', symbol: 'W/(cm·°C)', plural: 'Watts/Centimeter·°C', factor: 100 },
  { id: 'kilowatt-per-meter-kelvin', name: 'Kilowatt/Meter·K', symbol: 'kW/(m·K)', plural: 'Kilowatts/Meter·K', factor: 1000 },
  { id: 'calorie-per-second-cm-celsius', name: 'Calorie/Second·cm·°C', symbol: 'cal/(s·cm·°C)', plural: 'Calories/Second·cm·°C', factor: 418.68 },
  { id: 'kilocalorie-per-hour-m-celsius', name: 'Kilocalorie/Hour·m·°C', symbol: 'kcal/(h·m·°C)', plural: 'Kilocalories/Hour·m·°C', factor: 1.163 },
  { id: 'btu-per-hour-foot-fahrenheit', name: 'BTU/Hour·ft·°F', symbol: 'BTU/(h·ft·°F)', plural: 'BTU/Hour·ft·°F', factor: 1.7307347 },
  { id: 'btu-inch-per-hour-sqft-fahrenheit', name: 'BTU·in/Hour·ft²·°F', symbol: 'BTU·in/(h·ft²·°F)', plural: 'BTU·in/Hour·ft²·°F', factor: 0.1442279 },
];

export const popularThermalConductivityConversions = [
  { from: 'watt-per-meter-kelvin', to: 'btu-per-hour-foot-fahrenheit' },
  { from: 'btu-per-hour-foot-fahrenheit', to: 'watt-per-meter-kelvin' },
  { from: 'watt-per-meter-kelvin', to: 'calorie-per-second-cm-celsius' },
  { from: 'kilowatt-per-meter-kelvin', to: 'watt-per-meter-kelvin' },
  { from: 'watt-per-centimeter-celsius', to: 'watt-per-meter-kelvin' },
];

export const getUnitById = (id) => thermalConductivityUnits.find(unit => unit.id === id);

export const convertThermalConductivity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
